export default {
  actions: 'Our Action: R&D and Innovation',
  ac_ground: {
    ac0: 'Increase investment in R&D',
    ac0text:
      'The company continuously consolidates its technical strength, increases investment in R&D, strengthens the development of a high-end technical talent team, and sustains the long-term innovation capability of the enterprise.',
    ac1: 'R&D investment funds',
    ac1text:
      "In 2025, the company's R&D investment reached 4.2 billion yuan, a year-on-year increase of 32%.",

    ac2: 'R&D technical personnel',
    ac2text:
      'By the end of 2025, the number of R&D technical personnel reached 7,625, accounting for 40% of the total employees.',
    ac3: 'High-quality development of the industry',
    ac3text:
      'We comprehensively advance technological innovation and product innovation to boost high-quality development of the industry.',
  },
  project: {
    hotel: 'Star-rated Hotel',
    hospital: 'Hospital Engineering',
    school: 'School Engineering',
    company: 'Real Estate Company',
    other: 'Other Key Projects',
  },
  development: 'Governance Framework for Sustainable Development',
  developimg: require('@/assets/images/sustainability/susicon_en.png'),
};
